import React from "react";
import { UserContext } from "../../context";
import AuthUser from "../../models/auth-user";

type TProps = {
  children: React.ReactNode;
};

export default (props: TProps) => {
  const [loggedInUser, setLoggedInUser] = React.useState<undefined | AuthUser>(undefined);

  return <React.Fragment>
    <UserContext.Provider value={{
      loggedInUser, setLoggedInUser
    }}>{props.children}</UserContext.Provider>
  </React.Fragment>;
};
